import {
    SET_PAGE,
    RESET_PAGE
} from "../actions/pages.js"

const initialState = {}

export default (state = initialState, {
    type,
    payload
}) => {
    switch (type) {
        case SET_PAGE:
            return {
                ...payload
            }
        case RESET_PAGE:
            return initialState
        default:
            return state
    }
}